import { Injectable } from '@angular/core';
import { Mutation } from 'apollo-angular';
import gql from 'graphql-tag';
import { Widget } from '../query-definitions/system.graphql';

export interface UpdateUserSettingsMutationResponse {
  code: String;
  success: Boolean;
  message: String;
}

export interface ModelUserSettingsUpdateInput {
  key: String;
  value: String;
}

@Injectable({
  providedIn: 'root',
})
export class UpdateUserSettingsGQL extends Mutation<UpdateUserSettingsMutationResponse> {
  document = gql(`
    mutation updateUserSettings($uid: String!, $input: [ModelUserSettingsUpdateInput]) {
      updateUserSettings(uid: $uid, input: $input) {
        code
        success
        message
      }
    }
  `);
}

export interface UpdateUserSignInMutationResponse {
  code: String;
  success: Boolean;
  message: String;
}

@Injectable({
  providedIn: 'root',
})
export class UpdateUserSignIn extends Mutation<UpdateUserSignInMutationResponse> {
  document = gql(`
    mutation adminSignedIn($uid: ID!) {
      adminSignedIn(uid: $uid) {
        code
        success
        message
      }
    }
  `);
}

export interface InsertUserWidgetResponse {
  insertUserWidget: {
    code: String;
    success: Boolean;
    message: String;
    userWidget: UserWidget;
  };
}

export interface UserWidget extends Widget {
  parameters: string;
  order: number;
  userWidgetUid: string;
}

@Injectable({
  providedIn: 'root',
})
export class InsertUserWidget extends Mutation<InsertUserWidgetResponse> {
  document = gql(`
    mutation insertUserWidget($uid: ID!, $input: ModelInsertUserWidgetInput) {
      insertUserWidget(uid: $uid, input: $input) {
        code
        success
        message
        userWidget {
          uid
          parameters
          userWidgetUid
          name
          description
          url
          type
          order
        }
      }
    }
  `);
}

export interface UpdateUserWidgetResponse {
  insertUserWidget: {
    code: String;
    success: Boolean;
    message: String;
    userWidget: UserWidget;
  };
}

@Injectable({
  providedIn: 'root',
})
export class UpdateUserWidget extends Mutation<UpdateUserWidgetResponse> {
  document = gql(`
    mutation updateUserWidget($uid: ID!, $input: ModelUpdateUserWidgetInput) {
      updateUserWidget(uid: $uid, input: $input) {
        code
        message
        success
        userWidget {
          uid
          parameters
          order
        }
      }
    }
  `);
}

export interface DeleteUserWidgetResponse {
  deleteUserWidget: {
    code: String;
    success: Boolean;
    message: String;
  };
}

@Injectable({
  providedIn: 'root',
})
export class DeleteUserWidget extends Mutation<DeleteUserWidgetResponse> {
  document = gql(`
    mutation deleteUserWidget($uid: ID!) {
      deleteUserWidget(uid: $uid) {
        code
        success
        message
      }
    }
  `);
}

export interface ResetMfaResponse {
  resetMfa: {
    code: String;
    success: Boolean;
    message: String;
  };
}

export interface ResetMfaInput {
  uid: string;
}

@Injectable({
  providedIn: 'root',
})
export class ResetMfaGQL extends Mutation<ResetMfaResponse, ResetMfaInput> {
  document = gql(`
    mutation resetMfa($uid: ID!) {
      resetMfa(uid: $uid) {
        code
        success
        message
      }
    }
  `);
}
